import { makeObservable, observable, action, computed, reaction } from 'mobx';
import { messageStackState } from "/@/app/states/messageStackState";
import { clearLocalStorage } from './localStorage';

import { ValueState } from '/@/app/views/AgeCalculatorView/ValueState.js';
import { userFlowState } from '/@/app/states/userFlowState.js';

export class ValueListState {
    api=null;
    panelId;
    panel = null;
    values = [];
    saveState = "saved";

    constructor(values, panelId, api) {
	this.api=api;
        this.panelId = panelId;

        makeObservable(this, {
            values: observable,
            panel: observable,
            //
            saveState: observable,
            setSaveState: action,
            //
            saveAll: action,
            fetch: action,
            resetOnServer: action,
            _setValuesFromResponse: action,
        });

        this.values.replace(
            values.map(v => new ValueState(v, this.panelId))
        )

        // computed property won't react on nested states automatically,
        // so do it by hand:
        const searchUnsaved = () => {
            for (let value of this.values) {
                if (value.value_is_computed) { continue; }
                if (value.saveState !== "saved") {
                    this.setSaveState("unsaved");
                    return;
                }
            }
            this.setSaveState("saved");
        }
        // react on each field change
        for (let value of this.values) {
            reaction(() => value.saveState, () => {
                searchUnsaved();
            });
        }
        searchUnsaved();  // ensure initial state
    }

    setSaveState(state) {
        this.saveState = state;
    }

    _setValuesFromResponse(response) {
        this.values.replace(
            response.values.map(v => new ValueState(v, this.panelId))
        )
        this.panel = response.panel;
    }

    resetUnsaved() {
        clearLocalStorage(this.panelId);
        for (let value of this.values) {
            value.setValue(value.savedValue);
        }
    }
    resetOnServer() {
        this.setSaveState("resetting");
        this.resetUnsaved();
        this.values.clear();  // FIXME somehow they're not replaced w/o prior clear. Check React's side.
        this.api.request(`cabinet/age-calculator/panels/${this.panelId}/values/`, {}, {
            method: 'DELETE',
        }).then((response) => {
            this.setSaveState("saved");
            this._setValuesFromResponse(response);
        });
    }

    fetch() {
        this.setSaveState("fetching");
        this.api.request(`cabinet/age-calculator/panels/${this.panelId}/calculate/`, {}, {
            method: 'POST',
        }).then((response) => {
            this.setSaveState("saved");
            this._setValuesFromResponse(response);
        });
    }

    saveAll() {
        this.setSaveState("saving");

        let payload = [];
        for (let value of this.values) {
            const cleanValue = value.cleanValueType();
            payload.push({
                caption: value.caption,  // use caption as ID
                manual_value: cleanValue,
            });
        }

        this.api.request(`cabinet/age-calculator/panels/${this.panelId}/values/`, payload,  {
            method: 'PUT',
	    silentStatuses:{
		    422: (error) => {
			this.setSaveState("unsaved");
			messageStackState.addMessage({
			    text: "Проверьте что все поля верно заполнены",
			    tags: "error",
			    autoHide: 3000,
			});
		    },
	    }
	}).then((response) => {
            this.setSaveState("saved");
            // sets statuses in bulk
            clearLocalStorage(this.panelId);
            this._setValuesFromResponse(response);
            for (let value of this.values) {
                value.setSavedValue(value.value);
                value.setSaveState("saved");
            }
        }).catch((error) => {
            // skip. Don't retry.
            this.setSaveState("unsaved");
        });
    }
}
